var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},_vm._l((_vm.items),function(item){return _c('button',{key:item.name,class:_vm.$style.circle,style:({width: 10, height: 10}),on:{"click":function($event){_vm.handleClick(item.name)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fad86a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/molecules/Graphic.vue
// module id = 43
// module chunks = 0